module.exports = __webpack_public_path__ + "img/wheelchair-couple.f823df81.jpg";